module.exports = __webpack_public_path__ + "img/tgo.025deae8.svg";